import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxSelectBox = _resolveComponent("DxSelectBox")!

  return (_openBlock(), _createBlock(_component_DxSelectBox, {
    class: "CreateEditDialog-textbox",
    value: _ctx.modelValue,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modelValue) = $event)),
    "display-expr": "desc",
    "data-source": _ctx.dataSource,
    readOnly: _ctx.readOnly,
    onValueChanged: _ctx.valueChanged,
    disabled: _ctx.disabled,
    stylingMode: _ctx.stylingMode
  }, null, 8, ["value", "data-source", "readOnly", "onValueChanged", "disabled", "stylingMode"]))
}